package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.CalendarDemo

@Page
@Composable
fun CalendarPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/calendar.md", mapOf("title" to listOf("Calendar"), "description" to listOf("A date field component that allows users to enter and edit date.")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import react.FC
import react.Props
import react.useState
import shadcn.ui.components.Calendar
import web.cssom.ClassName
import kotlin.js.Date

val CalendarDemo = FC<Props> {
    val (date, setDate) = useState<Date>()

    Calendar {
        mode="single"
        selected= date
        onSelect= setDate
        className= ClassName("rounded-md border")
    }
}"""){ 
 CalendarDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("about")
 }) {
                org.jetbrains.compose.web.dom.Text("About")
            }
            org.jetbrains.compose.web.dom.P({ classes("leading-7","[&:not(:first-child)]:mt-6") }) {
                org.jetbrains.compose.web.dom.Text("The ")
                org.jetbrains.compose.web.dom.Code({ classes("bg-muted","py-[0.2rem]","px-[0.3rem]","rounded","text-sm") }) {
                    org.jetbrains.compose.web.dom.Text("Calendar")
                }
                org.jetbrains.compose.web.dom.Text(" component is built on top of ")
                org.jetbrains.compose.web.dom.A("https://react-day-picker.js.org", { classes("font-medium","underline","underline-offset-4") }) {
                    org.jetbrains.compose.web.dom.Text("React DayPicker")
                }
                org.jetbrains.compose.web.dom.Text(".")
            }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Calendar
""", lang= "kotlin", highlight= "")
            CodeBlock("""val (date, setDate) = useState<Date>()

Calendar {
    mode="single"
    selected= date
    onSelect= setDate
    className= ClassName("rounded-md border")
}
""", lang= "kotlin", highlight= "")
            org.jetbrains.compose.web.dom.P({ classes("leading-7","[&:not(:first-child)]:mt-6") }) {
                org.jetbrains.compose.web.dom.Text("See the ")
                org.jetbrains.compose.web.dom.A("https://react-day-picker.js.org", { classes("font-medium","underline","underline-offset-4") }) {
                    org.jetbrains.compose.web.dom.Text("React DayPicker")
                }
                org.jetbrains.compose.web.dom.Text(" documentation for more information.")
            }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("date-picker")
 }) {
                org.jetbrains.compose.web.dom.Text("Date Picker")
            }
            org.jetbrains.compose.web.dom.P({ classes("leading-7","[&:not(:first-child)]:mt-6") }) {
                org.jetbrains.compose.web.dom.Text("You can use the ")
                org.jetbrains.compose.web.dom.Code({ classes("bg-muted","py-[0.2rem]","px-[0.3rem]","rounded","text-sm") }) {
                    org.jetbrains.compose.web.dom.Text("<Calendar>")
                }
                org.jetbrains.compose.web.dom.Text(" component to build a date picker. See the ")
                org.jetbrains.compose.web.dom.A("/docs/components/date-picker", { classes("font-medium","underline","underline-offset-4") }) {
                    org.jetbrains.compose.web.dom.Text("Date Picker")
                }
                org.jetbrains.compose.web.dom.Text(" page for more information.")
            }
        }
    }
}
